import { useGoogleLogin as useGoogleLoginCore } from '@myfunnow/web-core'
import { useSocialLogin } from '@/composables/useSocialLogin'
import { QueryStringKeys } from '@/constants/commons'
import { toSafeInternalUrl } from '@/utils/common'

export function useGoogleLogin() {
  const config = useRuntimeConfig()
  const route = useRoute()
  const { loginWith } = useSocialLogin()

  const {
    isReady: isGoogleReady,
    initialize,
    renderButton,
  } = useGoogleLoginCore({
    clientId: config.public.googleAppId,
    onCredentialResponse: response => {
      handleCredentialResponse(response.credential)
    },
    idConfiguration: {
      cancel_on_tap_outside: false,
      auto_select: false,
    },
  })

  async function handleCredentialResponse(idToken: string) {
    const rawRedirectUrl = route.query[QueryStringKeys.REDIRECT_URL]
    const safeRedirectUrl = toSafeInternalUrl(typeof rawRedirectUrl === 'string' ? rawRedirectUrl : undefined)

    await loginWith('google', {
      token: idToken,
      redirectUrl: safeRedirectUrl,
      fallbackUrl: route.fullPath,
    })
  }

  return { isGoogleReady, initialize, renderButton }
}
